import { useState } from "react";

import { Button, Col, Row } from "react-bootstrap";

import { useQueryClient } from "@tanstack/react-query";


import edit from "@/assets/svg/edit.svg";
import Key from "@/assets/svg/Key";
import plan from "@/assets/svg/plan.svg";
import vr from "@/assets/svg/vr.svg";
import { Carousel } from "@/common/components/Carousel.tsx";
import MapComponent from "@/common/components/map/MapComponent";
import ModalDwellingExpress from "@/common/components/ModalDwellingExpress.tsx";

import Gauge from "./Gauge";
import { capitalizeWord, getValue } from "../../../../_helpers/stringHelper";
import { DataDwellingInfos } from "../../interfaces";
import { getLastTenant } from "../DwellingSheetDetails";




const DwellingInfo = ({ data }: { data: DataDwellingInfos }) => {
  const queryClient = useQueryClient();
  const titleHandler = () => {
    const title: string[] = [];
    if (data.lessor) title.push(capitalizeWord(data.lessor));
    if (data.address.address.address) title.push(data.address.address.address);
    return title.join(" - ");
  };

  const [showModalDwellingExpress, setShowModalDwellingExpress] =
    useState(false);

  return (
    <div className="bg-container dwelling_infos d-flex flex-column gap-3">
      <ModalDwellingExpress
        show={showModalDwellingExpress}
        id={data.id}
        onHide={() => {
          setShowModalDwellingExpress(false);
        }}
        onSubmit={async () => {
          await queryClient.invalidateQueries({ queryKey: ["dwellings"] });
          await queryClient.invalidateQueries({
            queryKey: ["dwelling", "infos", data.id],
          });
          document.location.reload();
        }}
      />
      <div className="dwelling_infos_header d-flex flex-column gap-3">
        <div className="dwelling_infos_title d-lg-flex justify-content-between">
          {titleHandler()}
          <div className="d-flex align-items-center gap-2">
            {data.linkVirtualVisit ? (
              <a
                target={"_blank"}
                className="btn dwelling_property-button_edit"
                href={data.linkVirtualVisit}
              >
                <img src={vr} alt="visite virtuelle" />
              </a>
            ) : null}
            <a className="btn dwelling_property-button_edit disabled">
              <img src={plan} alt="plan" />
            </a>
            <Button
              className="btn dwelling_property-button_edit"
              variant="outline-primary"
              onClick={() => setShowModalDwellingExpress(true)}
            >
              <img src={edit} alt="edit" />
            </Button>
          </div>
        </div>
      </div>
      <div className="border-bottom" />
      <div className="d-flex justify-content-between flex-wrap">
        <div className="d-flex gap-5">
          <div className="d-flex flex-column dwelling_infos_subtitle">
            <span>Adresse</span>
            <span>
              {data.address.address.address}&nbsp;
              {data.address.address.zip}&nbsp;
              {data.address.address.city}
            </span>
          </div>
          <div className="d-flex flex-column dwelling_infos_subtitle">
            <span>Propriétaire</span>
            <span>{getValue(data.lessor)}</span>
          </div>
          <div className="d-flex flex-column dwelling_infos_subtitle">
            <span>Occupant</span>
            <span>{getLastTenant(data.currentTenants)}</span>
          </div>
          <div className="d-flex flex-column dwelling_infos_subtitle">
            <span>Agence</span>
            <span>{data.agency.label}</span>
          </div>
        </div>
        {/* <div className="d-flex gap-2 align-items-center">
          <Key color="#641abf" />
          <a href="#" className="dwelling_infos_link">
            Localisation des clés
          </a>
        </div> */}
      </div>
      <Row>
        <Col xs={12} lg={6} className="">
          <MapComponent
            coordinates={
              data.address.address?.latitudeY &&
              data.address.address?.longitudeX
                ? {
                    lat: Number(data.address.address?.latitudeY),
                    lng: Number(data.address.address?.longitudeX),
                  }
                : undefined
            }
            style={{ borderRadius: "16px", height: "100%", minHeight: "250px" }}
          />
        </Col>
        <Col xs={12} lg={6}>
          <Carousel paths={data.roomPhotos} id={data.id} />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col
          xs={{ span: 12, order: 1 }}
          lg={{ span: 6, order: 1 }}
          className="propertySheetDetailsMainSubtitles mt-2 mt-lg-0"
        >
          Diagnostic de performance énergétique (DPE)
        </Col>
        <Col
          xs={{ span: 12, order: 3 }}
          lg={{ span: 6, order: 2 }}
          className="propertySheetDetailsMainSubtitles mt-2 mt-lg-0"
        >
          Emission de Gaz à effet de Serre (GES)
        </Col>
        <Col
          xs={{ span: 8, order: 2, offset: 2 }}
          lg={{ span: 6, order: 3, offset: 0 }}
          className="mt-1 mt-lg-2 px-lg-3"
        >
          <Gauge mode={"DPE"} value={data?.diagnostics?.EPD?.energy.class} />
        </Col>
        <Col
          xs={{ span: 8, order: 4, offset: 2 }}
          lg={{ span: 6, order: 4, offset: 0 }}
          className="mt-1 mt-lg-2 px-lg-3"
        >
          <Gauge mode={"GES"} value={data?.diagnostics?.EPD?.ghg.class} />
        </Col>
      </Row>
    </div>
  );
};

export default DwellingInfo;
